import React from 'react';
import {compose} from "recompose";
import {connect} from "react-redux";
import withUserRoleAuthorization from "./WithUserRoleAuthorization";
import {isNotGuestUser} from "../utils/userRoles";
import Dashboard from "./dashboard/Dashboard";

/**
 * The home page component that encapsulates the root directory's components.
 */
const HomePage = () => {
    return (
        <Dashboard />
    );
};

/**
 * User authorization - returns {@code true} if not null (i.e. guest user)
 */
const isSignedInCondition = (authUser) => isNotGuestUser(authUser);

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser
});

export default compose(
    withUserRoleAuthorization(isSignedInCondition),
    connect(mapStateToProps)
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage.jsx